<template>
  <div class="iso-card max-h-[calc(100vh-200px)] overflow-y-auto">
    <!-- Header -->
    <div class="px-4 py-3 border-b-2 border-neutral-900 flex items-center justify-between sticky top-0 bg-white">
      <h3 class="text-sm font-semibold text-slate-900 uppercase tracking-wider truncate">
        {{ gym.name }}
      </h3>
      <button
        class="text-slate-400 hover:text-slate-900 transition-colors"
        @click="$emit('close')">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Content -->
    <div class="p-4 space-y-4">
      <!-- Status Badge -->
      <div>
        <span
          class="px-2 py-1 text-xs font-medium uppercase tracking-wide border"
          :class="statusClass">
          {{ gym.status }}
        </span>
      </div>

      <!-- Location -->
      <div>
        <p class="text-xs text-slate-500 uppercase tracking-wider mb-1">
          Location
        </p>
        <p class="text-sm text-slate-900">
          {{ gym.address_line1 }}
        </p>
        <p class="text-sm text-slate-500">
          {{ gym.city }}<span v-if="gym.state">, {{ gym.state }}</span>
        </p>
      </div>

      <!-- Stats -->
      <div class="grid grid-cols-2 gap-3">
        <div>
          <p class="text-xs text-slate-500 uppercase tracking-wider">
            Rating
          </p>
          <p class="text-sm font-bold text-slate-900">
            {{ gym.average_rating ? gym.average_rating.toFixed(1) : '-' }}
          </p>
        </div>
        <div>
          <p class="text-xs text-slate-500 uppercase tracking-wider">
            Reviews
          </p>
          <p class="text-sm font-bold text-slate-900">
            {{ gym.review_count || 0 }}
          </p>
        </div>
      </div>

      <!-- Actions -->
      <div class="flex gap-2 pt-2 border-t border-slate-200">
        <a
          :href="`/admin/gyms/${gym.id}`"
          class="flex-1 px-3 py-2 border-2 border-neutral-900 text-xs font-semibold text-slate-900 uppercase tracking-wider bg-white hover:bg-slate-50 transition-colors text-center">
          VIEW
        </a>
        <a
          :href="`/admin/gyms/${gym.id}/edit`"
          class="flex-1 px-3 py-2 border-2 border-neutral-900 text-xs font-semibold text-slate-900 uppercase tracking-wider bg-white hover:bg-slate-50 transition-colors text-center">
          EDIT
        </a>
      </div>

      <div v-if="gym.status === 'pending'" class="flex gap-2">
        <button
          class="flex-1 px-3 py-2 border-2 border-green-600 text-xs font-semibold text-green-700 uppercase tracking-wider bg-green-50 hover:bg-green-100 transition-colors"
          @click="$emit('approve', gym)">
          APPROVE
        </button>
        <button
          class="flex-1 px-3 py-2 border-2 border-red-600 text-xs font-semibold text-red-700 uppercase tracking-wider bg-red-50 hover:bg-red-100 transition-colors"
          @click="$emit('reject', gym)">
          REJECT
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GymDetailPanel',

  props: {
    gym: {
      type: Object,
      required: true
    }
  },

  emits: ['close', 'approve', 'reject'],

  computed: {
    statusClass() {
      const classes = {
        approved: 'bg-green-100 text-green-800 border-green-300',
        pending: 'bg-amber-100 text-amber-800 border-amber-300',
        rejected: 'bg-red-100 text-red-800 border-red-300'
      }
      return classes[this.gym.status] || 'bg-slate-100 text-slate-800 border-slate-300'
    }
  }
}
</script>
